import React from 'react';
import './TaskBoard.css';
import Navbar from '../Navbar/Navbar';

const TaskBoard = () => {

    function drag(ev) {
        ev.dataTransfer.setData("text", ev.target.id);
    }

    function allowDrop(ev) {
        ev.preventDefault();
    }

    function drop(ev) {
        ev.preventDefault();
        var data = ev.dataTransfer.getData("text");
        ev.currentTarget.appendChild(document.getElementById(data));
    }





    
    




    return (
        <div >
      <Navbar/>
      <div className="container" style={{ height: '100vh', overflow: 'hidden' }}>
            <div className="kanban-board" style={{ height: 'calc(100vh - 50px)', overflow: 'hidden' }}>
                <div className="kanban-block" id="todo" onDrop={drop} onDragOver={allowDrop}>
                    <strong>To Do</strong>
                    
                    <div className="task-list" style={{ overflowY: 'auto', maxHeight: `calc(100vh - ${window.innerHeight * 0.2}px)` }}>
                       
                    <div className="task card dark" id="task1" draggable="true" onDragStart={drag}>
    <img src="https://codingyaar.com/wp-content/uploads/chair-image.jpg" className="card-img-top" alt="..."/>
    <div className="task card-body">
      <div className="text-section">
        <h5 className="card-title">Card title</h5>
        <p className="card-text">Some quick example text to build on the card's
          content.</p>
      </div>
      <div className="cta-section">
        <div>$129.00</div>
        <a href="#" className="btn btn-light">Buy Now</a>
      </div>
    </div>
  </div>
  <div className="task card bg-light-subtle mt-4" id="task2" draggable="true" onDragStart={drag}>
    <img src="https://codingyaar.com/wp-content/uploads/chair-image.jpg" className="card-img-top" alt="..."/>
    <div className="task card-body">
      <div className="text-section">
        <h5 className="card-title fw-bold">Card title</h5>
        <p className="card-text">Some quick example text to build on the card's content.</p>
      </div>
      <div className="cta-section">
        <div>$129.00</div>
        <a href="#" className="btn btn-dark">Buy Now</a>
      </div>
    </div>
  </div>
  <div className="task card bg-danger-subtle mt-4" id="task3" draggable="true" onDragStart={drag}>
    <img src="https://codingyaar.com/wp-content/uploads/chair-image.jpg" className="card-img-top" alt="..."/>
    <div className="task card-body">
      <div className="text-section">
        <h5 className="card-title fw-bold">Card title</h5>
        <p className="card-text">Some quick example text to build on the card's content.</p>
      </div>
      <div className="cta-section">
        <div>$129.00</div>
        <a href="#" className="btn btn-dark">Buy Now</a>
      </div>
    </div>
  </div>
  <div className="task card bg-primary-subtle mt-4" id="task4" draggable="true" onDragStart={drag}>
    <img src="https://codingyaar.com/wp-content/uploads/chair-image.jpg" className="card-img-top" alt="..."/>
    <div className="task card-body">
      <div className="text-section">
        <h5 className="card-title fw-bold">Card title</h5>
        <p className="card-text">Some quick example text to build on the card's content.</p>
      </div>
      <div className="cta-section">
        <div>$129.00</div>
        <a href="#" className="btn btn-dark">Buy Now</a>
      </div>
    </div>
  </div>
  <div className="task card bg-success-subtle mt-4" id="task5" draggable="true" onDragStart={drag}>
    <img src="https://codingyaar.com/wp-content/uploads/chair-image.jpg" className="card-img-top" alt="..."/>
    <div className="task card-body">
      <div className="text-section">
        <h5 className="card-title fw-bold">Card title</h5>
        <p className="card-text">Some quick example text to build on the card's content.</p>
      </div>
      <div className="cta-section">
        <div>$129.00</div>
        <a href="#" className="btn btn-dark">Buy Now</a>
      </div>
    </div>
  </div>
  <div className="task card bg-warning-subtle mt-4" id="task6" draggable="true" onDragStart={drag}>
    <img src="https://codingyaar.com/wp-content/uploads/chair-image.jpg" className="card-img-top" alt="..."/>
    <div className="task card-body">
      <div className="text-section">
        <h5 className="card-title fw-bold">Card title</h5>
        <p className="card-text">Some quick example text to build on the card's content.</p>
      </div>
      <div className="cta-section">
        <div>$129.00</div>
        <a href="#" className="btn btn-dark">Buy Now</a>
      </div>
    </div>
  </div>
  <div className="task card bg-info-subtle mt-4" id="task7" draggable="true" onDragStart={drag}>
    <img src="https://codingyaar.com/wp-content/uploads/chair-image.jpg" className="card-img-top" alt="..."/>
    <div className="task card-body">
      <div className="text-section">
        <h5 className="card-title fw-bold">Card title</h5>
        <p className="card-text">Some quick example text to build on the card's content.</p>
      </div>
      <div className="cta-section">
        <div>$129.00</div>
        <a href="#" className="btn btn-dark">Buy Now</a>
      </div>
    </div>
  </div>
 


                    </div>
                </div>
                <div className="kanban-block" id="inprogress" onDrop={drop} onDragOver={allowDrop}>
                    <strong>In Progress</strong>
                </div>
                <div className="kanban-block" id="done" onDrop={drop} onDragOver={allowDrop}>
                    <strong>Done</strong>
                </div>
    
            </div>
        </div>
        </div>
    );
};

export default TaskBoard;